// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import navbar from "./navbar";
import cryptoPrices from "./cryptoPrices";
import forms from "./forms"
import share from "./share"
import members from "./members"
import analytics from "./analytics"
import readingProgress from "./readingProgress"
import apiArticles from "./apiArticles"

navbar();
cryptoPrices()
forms()
share()
members()
analytics()
readingProgress()
apiArticles()
